/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './loading-content.module.css';

interface LoadingContentProps {
    message?: string;
    qaDataTag?: string;
    height?: number;
    lowProfile?: boolean;
    withMarginTop?: boolean;
    withMarginBottom?: boolean;
}

export const LoadingContent: React.FC<LoadingContentProps> = ({
    message,
    qaDataTag = 'loading-content-component',
    lowProfile = false,
    withMarginTop = true,
    withMarginBottom = true,
    height,
}: LoadingContentProps): React.ReactElement => {
    const { t } = useTranslation(['common']);

    return (
        <div
            style={{
                height: height ? `${height}rem` : 'auto',
                margin: '0',
                marginTop: withMarginTop ? '1rem' : '0',
                marginBottom: withMarginBottom ? '1rem' : '0',
                padding: lowProfile ? '1rem' : '2rem',
            }}
            className={styles.LoadingContent}
            data-testid={qaDataTag}
        >
            <p>{message || `${t('common:loading')}...`}</p>
        </div>
    );
};
